import $ from 'jquery';

const SmoothScroll = () => {
  $(document).on('click', '.js-scroll', function(e) {
    const href = $(this).attr('href');
    const hash = href.includes('#') ? '#' + href.split('#')[1] : null;
    const target = hash ? $(hash) : null;

    // ターゲットが現在のページに存在しない場合は通常遷移
    if (!target || !target.length) return;

    e.preventDefault();
    const position = target.offset().top;
    const shift = 0;
    $('html, body').animate({
      scrollTop: position + shift,
    }, 500);
  });
}

export default SmoothScroll;